/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Create a definition. This is the only serializer where ``owner`` is writable.
 * 
 * ``WorkflowDef.owner`` is a OneToOneField, so a company holds at most one definition, and
 * ModelSerializer derives the uniqueness validator for that on its own. The field is redeclared
 * below only to replace its default "must be unique" message with an actionable one.
 * @export
 * @interface WorkflowDefCreate
 */
export interface WorkflowDefCreate {
    /**
     * 
     * @type {string}
     * @memberof WorkflowDefCreate
     */
    readonly id: string;
    /**
     * 
     * @type {string}
     * @memberof WorkflowDefCreate
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof WorkflowDefCreate
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof WorkflowDefCreate
     */
    owner?: number | null;
    /**
     * Is this workflow active? Inactive definitions are not used in new workflows.
     * @type {boolean}
     * @memberof WorkflowDefCreate
     */
    isActive?: boolean;
    /**
     * When enabled, events from the same batch that share a grouping field (e.g. site or equipment) will be linked. Configure the linking rule below.
     * @type {boolean}
     * @memberof WorkflowDefCreate
     */
    autoEventLinking?: boolean;
}

/**
 * Check if a given object implements the WorkflowDefCreate interface.
 */
export function instanceOfWorkflowDefCreate(value: object): value is WorkflowDefCreate {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function WorkflowDefCreateFromJSON(json: any): WorkflowDefCreate {
    return WorkflowDefCreateFromJSONTyped(json, false);
}

export function WorkflowDefCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkflowDefCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'owner': json['owner'] === undefined ? undefined : json['owner'] === null ? null : json['owner'],
        'isActive': json['is_active'] == null ? undefined : json['is_active'],
        'autoEventLinking': json['auto_event_linking'] == null ? undefined : json['auto_event_linking'],
    };
}

export function WorkflowDefCreateToJSON(json: any): WorkflowDefCreate {
    return WorkflowDefCreateToJSONTyped(json, false);
}

export function WorkflowDefCreateToJSONTyped(value?: Omit<WorkflowDefCreate, 'id'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'owner': value['owner'],
        'is_active': value['isActive'],
        'auto_event_linking': value['autoEventLinking'],
    };
}

